/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m22 12v-3.66649629c0-3.49885341-2.829844-6.33350371-6.3203645-6.33350371-1.489287 0-2.897075.51638234-4.0207039 1.44594775-.4255392.35204378-1.0558947.29246395-1.4079385-.13307527-.35204379-.42553922-.29246396-1.05589478.1330753-1.40793855 1.4790273-1.22358258 3.3365623-1.90493393 5.2955671-1.90493393 4.5958505 0 8.3203645 3.73083985 8.3203645 8.33350371v3.66649629h3c.5522847 0 1 .4477153 1 1v16c0 .5522847-.4477153 1-1 1h-22c-.55228475 0-1-.4477153-1-1v-16c0-.5522847.44771525-1 1-1zm-16 16h20v-14h-20zm8.3537-9.0867c0-.911.738-1.653 1.646-1.653.909 0 1.648.742 1.648 1.653 0 .532-.257 1.001-.648 1.304v3.261c0 .552-.447 1-1 1-.552 0-1-.448-1-1v-3.261c-.39-.303-.646-.772-.646-1.304z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;